<template>
  <div>
    <PCNavbar selectIndex="1"/>
    <MobileNavBar :currentActive="0"/>
    <CarouselHome />
    <div class="content_middle">

      <div class="title">公司简介</div>
      <div class="desc">鑫宇宸成立于2022年，是一家专注于声学创新与智能音频技术研发的高科技企业。公司以“重塑声音体验，赋能品质生活”为使命，深耕音箱领域多年，致力于为用户提供兼具卓越音质、前沿设计与人性化功能的高端音频产品。</div>

      <div class="title">核心产品与技术</div>

      <div class="desc">公司主营智能音箱、家庭影院系统、便携式蓝牙音箱及专业级Hi-Fi音响设备，覆盖家用、商用及户外多场景需求。产品采用自研声学引擎，通过精密算法优化音场表现，实现高保真还原与沉浸式环绕声效；同时搭载AI语音交互、多设备无线互联等智能技术，满足现代用户对便捷操控与智慧家居融合的需求。外观设计融合极简美学与实用主义，选用环保材质与定制化工艺，打造兼具艺术感与功能性的声学艺术品。</div>

      <div class="title">市场与愿景</div>
      <div class="desc">凭借对声学技术的持续突破及用户需求的敏锐洞察，公司产品已获全球多个国家用户认可，并斩获红点设计奖、CES创新奖等国际殊荣。未来，公司将持续探索声学科技与智能生态的深度融合，以创新驱动行业升级，让世界听见更美好的声音。</div>
    </div>
    <!-- <TodoShow/> -->
    <!--
    <div class="bottom_circle">
      <h1>产业大脑将会是所有城市园区产业发展的标准配置</h1>
      <div class="circle_img">
        <img src="@/assets/img/lineimg.9cc3174a.png" alt="" class="hidden-xs-only"/>
        <img src="@/assets/img/lineimg.9cc3174a.png" alt="" class="hidden-sm-and-up"/>
      </div>
    </div>
    -->
    <!-- <CoreCompetence/> -->
    <!-- <CooperationCustomer/> -->
    <!-- <NewsInfomation/> -->
    <CallMe/>
    <MobileCallme/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import TodoShow from '@/components/todo_show/index'
import CoreCompetence from '@/components/core_competence/index'
import CooperationCustomer from '@/components/cooperation_customer/index'
import NewsInfomation from '@/components/news_infomation/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    TodoShow,
    CoreCompetence,
    CooperationCustomer,
    NewsInfomation,
    CallMe,
    MobileCallme
  },
}
</script>

<style lang="scss" scoped>
.content_middle {
  width: 100%;
  height: auto;
  padding-left: 200px;
  padding-right: 200px;
  margin-top: 60px;
  margin-bottom: 60px;

  .title {
    font-weight: 600; 
    font-size: 40px;
    margin-top: 40px;
  }
  .desc {
    font-weight: 200; 
    font-size: 28px;
  }

}

.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }
}
</style>